import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./theme/theme.css";
import "./theme/plus.css";
import "./initFacturxSuiteAuth";
import App from "./App";
import { markFacturxBootSplashBorn } from "./facturxBootSplash";
import { ThemeProvider } from "./theme/ThemeProvider";
import { bootFxTheme } from "./theme/theme";
import { syncUserIdFromQuery } from "./suiteSession";

markFacturxBootSplashBorn();
bootFxTheme();
syncUserIdFromQuery();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
);
